import {
  type PartnerPatientReportResponse as GeneratedPartnerPatientReportResponse,
  type PartnerPatientAppointmentResponse as GeneratedPartnerPatientAppointmentResponse,
  type PartnerPatientSlotHistoryResponse as GeneratedPartnerPatientSlotHistoryResponse,
  type ServiceReportItemResponse as GeneratedServiceReportItemResponse,
  type PatientReportSlotResponse as GeneratedPatientReportSlotResponse,
  type PatientReportDayResponse as GeneratedPatientReportDayResponse,
  type PatientReportServiceResponse as GeneratedPatientReportServiceResponse,
  type PatientsWeeklyReportResponse as GeneratedPatientsWeeklyReportResponse,
  type ServicesReportResponse as GeneratedServicesReportResponse,
  AppAccessStatus as GeneratedAppAccessStatus,
} from '@generated/models'

export type ServiceReportItemResponse = GeneratedServiceReportItemResponse

export type ServicesReportResponse = GeneratedServicesReportResponse

export type PatientReportSlotResponse = GeneratedPatientReportSlotResponse

export type PatientReportDayResponse = GeneratedPatientReportDayResponse

export type PatientReportServiceResponse = GeneratedPatientReportServiceResponse

export type PatientsWeeklyReportResponse = GeneratedPatientsWeeklyReportResponse

// Partner Patient Report types
export type PartnerPatientReportResponse = GeneratedPartnerPatientReportResponse
export type PartnerPatientAppointmentResponse =
  GeneratedPartnerPatientAppointmentResponse
export type PartnerPatientSlotHistoryResponse =
  GeneratedPartnerPatientSlotHistoryResponse
export {GeneratedAppAccessStatus as AppAccessStatus}
